import $ from 'jquery';

import { isMaxTablet } from 'chairisher/util/mediaquery';

/**
 * View that encapsulates functionality related to folder the settings menu
 *
 * @param {Object} settings
 * @param {jQuery} settings.$deactivateTriggerEl jQuery element that triggers a deactivation confirmation
 * @param {jQuery} settings.$menuEl jQuery element representing the menu
 * @param {jQuery} settings.$menuTriggerEls jQuery elements that toggle the menu's visibility
 * @param {number} settings.collectionId The id of the collection this menu is for
 * @param {string} settings.deactivateUrl The URL to POST to to deactivate the folder
 *
 * @class FolderMenuView
 * @constructs FolderMenuView
 */
const FolderMenuView = function (settings) {
    settings = $.extend(
        {
            $deactivateTriggerEl: this._$deactivateTriggerEl,
            $menuEl: this._$menuEl,
            $menuTriggerEls: this._$menuTriggerEls,
            collectionId: this._collectionId,
            deactivateUrl: this._deactivateUrl,
        },
        settings,
    );

    this._$deactivateTriggerEl = settings.$deactivateTriggerEl;
    this._$menuEl = settings.$menuEl;
    this._$menuTriggerEls = settings.$menuTriggerEls;

    this._collectionId = settings.collectionId;
    this._deactivateUrl = settings.deactivateUrl;

    this._bind();
};

/**
 * Static factory method to create a new FolderMenuView instance.
 *
 * @param {Object} settings - Configuration options for the FolderMenuView.
 * @returns {FolderMenuView} A new FolderMenuView instance.
 */
FolderMenuView.create = (settings) => new FolderMenuView(settings);

/**
 * jQuery element that, when pressed, triggers a deactivation confirmation
 *
 * @type {jQuery}
 * @private
 */
FolderMenuView.prototype._$deactivateTriggerEl = null;

/**
 * jQuery element representing the menu
 *
 * @type {jQuery}
 * @private
 */
FolderMenuView.prototype._$menuEl = null;

/**
 * jQuery elements that toggle the menu's visibility
 *
 * @type {jQuery}
 * @private
 */
FolderMenuView.prototype._$menuTriggerEls = null;

/**
 * The id of the collection this menu is for
 *
 * @type {number}
 * @private
 */
FolderMenuView.prototype._collectionId = null;

/**
 * The URL to POST to to deactivate the folder
 *
 * @type {string}
 * @private
 */
FolderMenuView.prototype._deactivateUrl = null;

/**
 * Toggles the visibility of the menu
 */
FolderMenuView.prototype.toggle = function () {
    this._$menuEl.toggleClass('show');
};

/**
 * Binds various events to the components that comprise this view
 *
 * @private
 */
FolderMenuView.prototype._bind = function () {
    //
    // Expand / Collapse
    //

    this._$menuEl.on(
        'click',
        '.js-menu-title',
        $.proxy(function () {
            this._$menuEl.find('.js-menu-title .cicon').toggleClass('hidden');
            this._$menuEl.find('.js-menu-content').collapse('toggle');
        }, this),
    );

    //
    // Toggle Visibility
    //

    this._$menuTriggerEls.on(
        'click',
        $.proxy(function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
        }, this),
    );

    this._$menuEl.find('a').on('click', (e) => {
        e.stopPropagation(); // prevent from bubbling to document which will close the menu
    });

    //
    // Deactivation Confirmation
    //

    this._$deactivateTriggerEl
        .on('click', (e) => {
            e.preventDefault();
        })
        .popover({
            content: $.proxy(function () {
                const $div = $('<div></div>');
                $div.html($('#js-deactivate-popover-template').html());
                $div.find('.js-deactivate-form').attr({
                    'action': this._deactivateUrl,
                    'data-folder-id': this._collectionId,
                });
                return $div[0].innerHTML;
            }, this),
            html: true,
            placement() {
                return isMaxTablet() ? 'bottom' : 'right';
            },
            trigger: 'focus',
            title: 'Delete', // todo: get from JS context
        });

    //
    // Toggle Visibility Clicking Outside of Menu
    //

    if (isMaxTablet()) {
        $(document.body).on('click', () => {
            $('.js-folder-menu').removeClass('show');
        });
    }
};

export default FolderMenuView;
